(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('.pearhaus-progressive-newsletter');

    for (const form of forms) {
      if (form.dataset.pearhausProgressiveReady === 'true') continue;
      form.dataset.pearhausProgressiveReady = 'true';

      const profileStep = form.querySelector('[data-pearhaus-newsletter-profile-step]');
      const emailField = form.querySelector('input[name="contact[email]"]');
      const firstNameField = form.querySelector('input[name="contact[first_name]"]');
      const lastNameField = form.querySelector('input[name="contact[last_name]"]');
      const saveButton = profileStep && profileStep.querySelector('button[type="button"]');
      const savedStatus = form.querySelector('[data-pearhaus-newsletter-saved]');

      if (emailField) {
        form.addEventListener('submit', () => {
          const email = emailField.value.trim().toLowerCase();
          if (!email) return;
          try { window.localStorage.setItem('pearhaus_progressive_newsletter_email_v1', email); } catch (_) {}
        });
      }

      if (!profileStep || !saveButton) continue;

      saveButton.addEventListener('click', () => {
        let email = emailField ? emailField.value.trim().toLowerCase() : '';
        if (!email) {
          try { email = String(window.localStorage.getItem('pearhaus_progressive_newsletter_email_v1') || '').trim().toLowerCase(); } catch (_) {}
        }
        const firstName = firstNameField ? firstNameField.value.trim() : '';
        const lastName = lastNameField ? lastNameField.value.trim() : '';
        if (!email) return;

        const profile = {
          '$email': email,
          ...(firstName ? { '$first_name': firstName } : {}),
          ...(lastName ? { '$last_name': lastName } : {})
        };
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify(profile);
        } else {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', profile]);
        }

        window.dispatchEvent(new CustomEvent('pearhausNewsletterProfileEnriched', {
          detail: { email, firstName, lastName, formId: form.id }
        }));

        saveButton.disabled = true;
        if (savedStatus) savedStatus.hidden = false;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-tahlia-product"]) return;
  try {
    
  class MetaTahliaProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-meta-form]');
      this.primaryCta = this.querySelector('[data-primary-cta]');
      this.heroImage = this.querySelector('.meta-hero__image');
      this.status = this.querySelector('[data-form-status]');
      this.hiddenVariant = this.querySelector('[data-variant-id]');
      this.sticky = this.querySelector('[data-sticky-cta]');
      this.suppressPromotionalPopups();
      this.enforceOneTimePurchase();
      this.bindSystemOptions();
      this.bindStyleOptions();
      this.bindForm();
      this.bindSticky();
      this.querySelector('[data-scroll-to-purchase]')?.addEventListener('click', () => this.primaryCta?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      this.querySelectorAll('.meta-proof video').forEach((video) => {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting ? video.play().catch(() => {}) : video.pause()), { threshold: .45 });
        observer.observe(video);
      });
    }

    suppressPromotionalPopups() {
      const removePopups = () => document.querySelectorAll('.klaviyo-form, [data-testid*="klaviyo"], [class*="kl-private"], [class*="jdgm-rev-widg__popup"], [class*="jdgm-notification"]').forEach((node) => node.remove());
      removePopups();
      this.popupObserver = new MutationObserver(removePopups);
      this.popupObserver.observe(document.body, { childList: true, subtree: true });
    }

    enforceOneTimePurchase() {
      const removeSubscriptionControls = () => this.form?.querySelectorAll('input[name="selling_plan"], [class*="sls-"], [id*="seal-subscription"], [class*="seal-subscription"], [data-seal-subscriptions]').forEach((node) => node.remove());
      removeSubscriptionControls();
      this.subscriptionObserver = new MutationObserver(removeSubscriptionControls);
      if (this.form) this.subscriptionObserver.observe(this.form, { childList: true, subtree: true });
    }

    bindSystemOptions() {
      this.querySelectorAll('[data-system-option]').forEach((button) => button.addEventListener('click', () => {
        const handle = button.dataset.productHandle;
        const currentStyle = this.querySelector('[data-selected-style]')?.textContent?.trim() || 'Tahlia';
        this.querySelectorAll('[data-system-option]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.querySelectorAll('[data-style-group]').forEach((group) => { group.hidden = group.dataset.styleGroup !== handle; });
        const target = Array.from(this.querySelectorAll(`[data-style-option][data-product-handle="${handle}"]`))
          .find((option) => option.dataset.variantName === currentStyle && !option.disabled)
          || this.querySelector(`[data-style-option][data-product-handle="${handle}"][data-variant-name="Tahlia"]`)
          || this.querySelector(`[data-style-option][data-product-handle="${handle}"]:not(:disabled)`);
        target?.click();
      }));
    }

    bindStyleOptions() {
      this.querySelectorAll('[data-style-option]').forEach((button) => button.addEventListener('click', () => {
        if (button.disabled) return;
        this.querySelectorAll('[data-style-option]').forEach((item) => {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        this.hiddenVariant.value = button.dataset.variantId;
        this.querySelector('[data-selected-system]').textContent = button.dataset.productLabel;
        this.querySelector('[data-selected-style]').textContent = button.dataset.variantName;
        this.querySelector('[data-sticky-style]').textContent = `${button.dataset.variantName} · ${button.dataset.productLabel}`;
        const price = Number(button.dataset.variantPrice || 0);
        const currency = window.Shopify?.currency?.active || 'CAD';
        const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency });
        this.querySelector('[data-base-price]').textContent = formatter.format(price / 100);
        this.querySelector('[data-offer-price]').textContent = this.dataset.offerLabel.replace('__PRICE__', formatter.format(price * .8 / 100));
        this.querySelector('[data-sticky-price]').textContent = formatter.format(price * .8 / 100);
        if (this.heroImage && button.dataset.variantImage) this.heroImage.src = button.dataset.variantImage;
        this.primaryCta.disabled = button.dataset.available !== 'true';
        const addLabel = this.primaryCta.querySelector('[data-add-label]');
        addLabel.textContent = this.primaryCta.disabled
          ? this.dataset.soldOutLabel
          : this.dataset.addTemplate.replace('__STYLE__', button.dataset.variantName).replace('__SYSTEM__', button.dataset.productLabel);
        const url = new URL(window.location.href);
        url.searchParams.set('view', 'meta-tahlia');
        url.searchParams.set('variant', button.dataset.variantId);
        window.history.replaceState({}, '', url);
      }));
    }

    bindForm() {
      this.form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.primaryCta.disabled) return;
        const label = this.primaryCta.querySelector('[data-add-label]');
        const original = label.textContent;
        this.primaryCta.disabled = true;
        label.textContent = this.dataset.addingLabel;
        this.status.textContent = '';
        try {
          const payload = new FormData();
          payload.append('id', this.hiddenVariant.value);
          payload.append('quantity', '1');
          const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
          if (!response.ok) throw new Error('add_failed');
          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-meta-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
          label.textContent = this.dataset.addedLabel;
          const link = document.createElement('a');
          link.href = this.dataset.cartUrl;
          link.textContent = this.dataset.viewCartLabel;
          this.status.replaceChildren(link);
        } catch (error) {
          label.textContent = original;
          this.status.textContent = this.dataset.errorLabel;
        } finally {
          this.primaryCta.disabled = false;
        }
      });
    }

    bindSticky() {
      if (!this.primaryCta || !this.sticky) return;
      const observer = new IntersectionObserver(([entry]) => { this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: .1 });
      observer.observe(this.primaryCta);
      this.querySelector('[data-sticky-submit]')?.addEventListener('click', () => this.form?.requestSubmit());
    }
  }
  if (!customElements.get('meta-tahlia-product')) customElements.define('meta-tahlia-product', MetaTahliaProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-category-shop"] && !Shopify.designMode) return;
  try {
    
  class PearhausCategoryShop extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-category-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
      this.desktopQuery = window.matchMedia('(min-width: 1000px)');
      this.activeCategory = 'all';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.categoryTab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });

      this.desktopQuery.addEventListener('change', () => this.syncPanels());
      this.activate('all');
    }

    activate(category) {
      this.activeCategory = category;

      this.tabs.forEach((tab) => {
        const selected = tab.dataset.categoryTab === category;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });

      this.syncPanels();
    }

    syncPanels() {
      this.panels.forEach((panel) => {
        const visible = !this.desktopQuery.matches || this.activeCategory === 'all' || panel.dataset.categoryPanel === this.activeCategory;
        panel.setAttribute('aria-hidden', String(!visible));
      });
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      this.activate(nextTab.dataset.categoryTab);
      nextTab.focus();
    }
  }

  if (!customElements.get('pearhaus-category-shop')) {
    customElements.define('pearhaus-category-shop', PearhausCategoryShop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-cluster-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pearhaus-cluster-builder')) {
    customElements.define('pearhaus-cluster-builder', class PearhausClusterBuilder extends HTMLElement {
      connectedCallback() {
        this.catalog = JSON.parse(this.querySelector('[data-cluster-catalog]').textContent);
        this.variants = this.catalog.products.flatMap((item) => item.variants.map((variant) => ({ ...variant, productId: item.id, productHandle: item.handle, productTitle: item.title, productDescription: item.description })));
        this.quantities = new Map();
        this.stockUpEnabled = this.dataset.stockUpEnabled === 'true';
        this.bundleQuantity = 1;
        this.mode = 'one-time';
        this.cadence = '60';
        const queryVariant = new URLSearchParams(window.location.search).get('variant');
        const initial = this.variants.find((variant) => String(variant.id) === String(queryVariant || this.dataset.initialVariant) && variant.available) || this.variants.find((variant) => variant.available);
        this.primaryVariantId = String(initial?.id || '');
        if (initial) this.quantities.set(this.primaryVariantId, 1);
        this.bindEvents();
        this.render();
      }

      bindEvents() {
        this.querySelectorAll('[data-style-choice]').forEach((button) => button.addEventListener('click', () => this.chooseStyle(button.closest('[data-variant-row]')?.dataset.variantId)));
        this.querySelectorAll('[data-increase]').forEach((button) => button.addEventListener('click', () => this.adjustQuantity(button.closest('[data-variant-row]')?.dataset.variantId, 1)));
        this.querySelectorAll('[data-decrease]').forEach((button) => button.addEventListener('click', () => this.adjustQuantity(button.closest('[data-variant-row]')?.dataset.variantId, -1)));
        this.querySelectorAll('[data-bundle-quantity]').forEach((input) => input.addEventListener('change', () => this.setBundleQuantity(Number(input.value) || 1)));
        this.querySelectorAll('[data-purchase-mode]').forEach((input) => input.addEventListener('change', () => { this.mode = input.value; this.clearMessages(); this.render(); }));
        this.querySelectorAll('[data-cadence]').forEach((button) => button.addEventListener('click', () => { this.cadence = button.dataset.cadence; this.clearMessages(); this.render(); }));
        this.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => button.addEventListener('click', () => this.selectGalleryImage(button)));
        this.querySelector('[data-add-to-cart]')?.addEventListener('click', () => this.addToCart());
      }

      variant(variantId) { return this.variants.find((item) => String(item.id) === String(variantId)); }
      primaryVariant() { return this.variant(this.primaryVariantId); }
      totalQuantity() { return [...this.quantities.values()].reduce((sum, quantity) => sum + Number(quantity || 0), 0); }
      selectedItems() { return this.variants.filter((variant) => Number(this.quantities.get(String(variant.id)) || 0) > 0).map((variant) => ({ ...variant, quantity: Number(this.quantities.get(String(variant.id))) })); }
      tierPercent(quantity = this.bundleQuantity) { if (!this.stockUpEnabled) return 0; if (quantity >= 3) return Number(this.dataset.tierThree) || 15; if (quantity === 2) return Number(this.dataset.tierTwo) || 10; return 0; }
      normalizeCadence(allocation) { const text = [allocation?.name, ...(allocation?.options || [])].join(' ').toLowerCase(); if (/60|2\s*month|bi[- ]?monthly|every other month/.test(text)) return '60'; if (/30|monthly|month/.test(text)) return '30'; return ''; }
      allocation(variant, cadence = this.cadence) { return variant?.allocations?.find((item) => this.normalizeCadence(item) === cadence); }
      canSubscribe(cadence) { const items = this.selectedItems(); return items.length > 0 && items.every((item) => Boolean(this.allocation(item, cadence))); }

      chooseStyle(variantId) {
        const variant = this.variant(variantId);
        if (!variant?.available) return;
        this.primaryVariantId = String(variantId);
        if (this.bundleQuantity === 1) {
          this.quantities.clear();
          this.quantities.set(this.primaryVariantId, 1);
        } else if (!this.quantities.has(this.primaryVariantId)) {
          this.adjustQuantity(this.primaryVariantId, 1);
        }
        this.clearMessages();
        this.render();
      }

      setBundleQuantity(quantity) {
        this.bundleQuantity = Math.max(1, Math.min(3, quantity));
        if (!this.primaryVariant()?.available) this.primaryVariantId = String(this.variants.find((variant) => variant.available)?.id || '');
        let current = this.totalQuantity();
        if (current < this.bundleQuantity) this.quantities.set(this.primaryVariantId, Number(this.quantities.get(this.primaryVariantId) || 0) + this.bundleQuantity - current);
        if (current > this.bundleQuantity) {
          let excess = current - this.bundleQuantity;
          [...this.quantities.entries()].reverse().forEach(([variantId, amount]) => {
            if (!excess) return;
            const remove = Math.min(amount, excess);
            const next = amount - remove;
            if (next) this.quantities.set(variantId, next); else this.quantities.delete(variantId);
            excess -= remove;
          });
          if (!this.quantities.size) this.quantities.set(this.primaryVariantId, this.bundleQuantity);
        }
        this.clearMessages();
        this.render();
      }

      adjustQuantity(variantId, delta) {
        const variant = this.variant(variantId);
        if (!variant?.available) return;
        const current = Number(this.quantities.get(String(variantId)) || 0);
        if (delta > 0 && this.totalQuantity() >= this.bundleQuantity) return;
        const next = Math.max(0, current + delta);
        if (next) this.quantities.set(String(variantId), next); else this.quantities.delete(String(variantId));
        if (!this.quantities.size) { this.primaryVariantId = String(variantId); this.quantities.set(this.primaryVariantId, 1); }
        if (next > 0) this.primaryVariantId = String(variantId);
        this.clearMessages();
        this.render();
      }

      priceState(mode = this.mode, cadence = this.cadence) {
        const items = this.selectedItems();
        if (!items.length || this.totalQuantity() !== this.bundleQuantity || items.some((item) => !item.available)) return { base: null, total: null };
        if (mode === 'subscription' && !this.canSubscribe(cadence)) return { base: null, total: null };
        const regularBase = items.reduce((sum, item) => sum + Number(item.price) * item.quantity, 0);
        const purchaseBase = items.reduce((sum, item) => sum + Number(mode === 'subscription' ? this.allocation(item, cadence)?.price : item.price) * item.quantity, 0);
        return { base: regularBase, purchaseBase, total: Math.round(purchaseBase * (1 - this.tierPercent() / 100)) };
      }

      formatMoney(cents) { if (cents === null || cents === undefined || Number.isNaN(Number(cents))) return '--'; try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.dataset.currency || 'CAD' }).format(Number(cents) / 100); } catch (error) { return `${(Number(cents) / 100).toFixed(2)} ${this.dataset.currency || ''}`.trim(); } }
      validSelection() { return this.totalQuantity() === this.bundleQuantity && this.selectedItems().every((item) => item.available) && (this.mode !== 'subscription' || this.canSubscribe(this.cadence)); }

      render() {
        const canSubscribe30 = this.canSubscribe('30');
        const canSubscribe60 = this.canSubscribe('60');
        if (this.mode === 'subscription' && !this.canSubscribe(this.cadence)) {
          if (canSubscribe60) this.cadence = '60'; else if (canSubscribe30) this.cadence = '30'; else this.mode = 'one-time';
        }
        const active = this.primaryVariant();
        const oneTime = this.priceState('one-time');
        const subscriptionCadence = canSubscribe60 ? '60' : '30';
        const subscription = this.priceState('subscription', subscriptionCadence);
        const current = this.priceState();
        const regularValue = oneTime.base;
        const totalSavings = regularValue === null || current.total === null ? 0 : Math.max(0, regularValue - current.total);
        const bundleSavings = regularValue === null || oneTime.total === null ? 0 : Math.max(0, regularValue - oneTime.total);
        const extraSavings = this.mode === 'subscription' && oneTime.total !== null && current.total !== null ? Math.max(0, oneTime.total - current.total) : 0;

        this.classList.toggle('is-mixing', this.bundleQuantity > 1);
        this.querySelector('[data-product-title]').textContent = active?.productTitle || '';
        this.querySelector('[data-product-description]').innerHTML = active?.productDescription || '';
        const hero = this.querySelector('[data-gallery-image]');
        if (hero && active?.image) { hero.src = active.image; hero.alt = active.alt || active.title; }
        this.querySelector('[data-cost-per-wear]').textContent = current.total === null ? '--' : this.formatMoney(current.total / (this.bundleQuantity * Number(this.dataset.wearsPerTray || 18)));
        this.querySelector('[data-total-price]').textContent = this.formatMoney(current.total);
        const savingsLine = this.querySelector('[data-savings-line]');
        savingsLine.hidden = totalSavings <= 0;
        savingsLine.querySelector('[data-savings-price]').textContent = totalSavings > 0 ? this.formatMoney(totalSavings) : '';
        const extraLine = this.querySelector('[data-extra-savings-line]');
        extraLine.hidden = extraSavings <= 0;
        extraLine.querySelector('[data-extra-savings-price]').textContent = extraSavings > 0 ? this.formatMoney(extraSavings) : '';

        this.querySelectorAll('[data-variant-row]').forEach((row) => {
          const variant = this.variant(row.dataset.variantId);
          const amount = Number(this.quantities.get(String(row.dataset.variantId)) || 0);
          row.classList.toggle('is-primary', String(row.dataset.variantId) === String(this.primaryVariantId));
          row.querySelector('[data-style-choice]').setAttribute('aria-pressed', String(String(row.dataset.variantId) === String(this.primaryVariantId)));
          row.querySelector('[data-quantity]').textContent = String(amount);
          row.querySelector('[data-decrease]').disabled = amount <= 0;
          row.querySelector('[data-increase]').disabled = !variant?.available || this.totalQuantity() >= this.bundleQuantity;
        });
        this.querySelectorAll('[data-bundle-quantity]').forEach((input) => { input.checked = Number(input.value) === this.bundleQuantity; });
        const mixStatus = this.querySelector('[data-mix-status]');
        if (mixStatus) {
          mixStatus.textContent = this.bundleQuantity === 1 ? 'One tray selected.' : `${this.totalQuantity()} of ${this.bundleQuantity} trays selected. Mix styles or stock up on your favourite.`;
        }
        this.querySelectorAll('[data-volume-cost]').forEach((node) => {
          const quantity = Number(node.dataset.volumeQuantity || 1);
          const unitPrice = Number(active?.price || 0);
          const total = Math.round(unitPrice * quantity * (1 - this.tierPercent(quantity) / 100));
          node.textContent = `${this.formatMoney(total / (quantity * Number(this.dataset.wearsPerTray || 18)))}/wear`;
        });

        this.querySelectorAll('[data-purchase-mode]').forEach((input) => { input.checked = input.value === this.mode; input.disabled = input.value === 'subscription' && !canSubscribe30 && !canSubscribe60; });
        this.querySelector('[data-purchase-total="one-time"]').textContent = this.formatMoney(oneTime.total);
        this.querySelector('[data-purchase-total="subscription"]').textContent = this.formatMoney(subscription.total);
        const plans = this.querySelector('[data-subscription-plans]');
        plans.hidden = this.mode !== 'subscription';
        this.querySelectorAll('[data-cadence]').forEach((button) => { const available = this.canSubscribe(button.dataset.cadence); button.disabled = !available; button.classList.toggle('is-active', available && button.dataset.cadence === this.cadence); button.setAttribute('aria-pressed', String(available && button.dataset.cadence === this.cadence)); });
        const planStatus = this.querySelector('[data-plan-status]');
        planStatus.hidden = this.mode !== 'subscription' || this.canSubscribe(this.cadence);
        planStatus.textContent = this.dataset.planUnavailableLabel;
        const discountNote = this.querySelector('[data-discount-note]');
        discountNote.hidden = bundleSavings <= 0;
        discountNote.textContent = bundleSavings > 0 ? `${this.tierPercent()}% stock-up savings applied. Subscription saves an extra 10% on top.` : '';
        this.querySelector('[data-add-to-cart]').disabled = !this.validSelection();
      }

      selectGalleryImage(button) { const image = this.querySelector('[data-gallery-image]'); if (!image) return; image.src = button.dataset.gallerySrc; image.alt = button.dataset.galleryAlt || ''; this.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', String(selected)); }); }
      clearMessages() { this.querySelector('[data-error]').hidden = true; this.querySelector('[data-success]').hidden = true; }
      showError(message) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; }

      async refreshCartUi() {
        if (typeof window.monster_refresh === 'function') {
          await window.monster_refresh(true);
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (typeof window.monster_refresh !== 'function') {
          await new Promise((resolve) => window.setTimeout(resolve, 100));
          document.querySelector('cart-drawer')?.show?.();
        }
      }

      async addToCart() {
        if (!this.validSelection()) return;
        const button = this.querySelector('[data-add-to-cart]');
        const label = this.querySelector('[data-add-label]');
        const loading = this.querySelector('[data-loading-label]');
        button.disabled = true; label.hidden = true; loading.hidden = false; this.clearMessages();
        const bundleId = `pearhaus-clusters-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const cadence = this.mode === 'subscription' ? this.cadence : 'one-time';
        const items = this.selectedItems().map((variant) => {
          const properties = { _pearhaus_cluster_system: this.dataset.systemKey, _pearhaus_cadence: cadence, _pearhaus_offer_mode: this.mode };
          if (this.stockUpEnabled) Object.assign(properties, { _pearhaus_bundle_id: bundleId, _pearhaus_bundle_tier: `Stock up ${this.tierPercent()}%`, _pearhaus_offer_source: 'cluster-stock-up-builder', _pearhaus_offer_quantity: String(this.bundleQuantity) });
          const item = { id: Number(variant.id), quantity: Number(variant.quantity), properties };
          if (this.mode === 'subscription') item.selling_plan = Number(this.allocation(variant, this.cadence).id);
          return item;
        });
        try {
          const response = await fetch(`${this.dataset.rootUrl.replace(/\/$/, '')}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Cart request failed');
          await this.refreshCartUi();
          const success = this.querySelector('[data-success]'); success.hidden = false; success.focus();
        } catch (error) { this.showError(this.dataset.errorLabel); }
        finally { label.hidden = false; loading.hidden = true; this.render(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-home-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function initializePearhausResponsiveCtaOrder() {
    const stateKey = '__pearhausResponsiveCtaOrder';

    const placeCta = () => {
      const ctaSection = document.querySelector("[id$='__pearhaus_final_cta']");
      const founderSection = document.querySelector("[id$='__pearhaus_founder_story']");
      const trustIconsSection = document.querySelector("[id$='__trust_icons_Xzby3e']");

      if (!ctaSection || !founderSection || !trustIconsSection) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        if (trustIconsSection.nextElementSibling !== ctaSection) {
          trustIconsSection.parentNode.insertBefore(ctaSection, trustIconsSection.nextElementSibling);
        }
      } else if (founderSection.nextElementSibling !== ctaSection) {
        founderSection.parentNode.insertBefore(ctaSection, founderSection.nextElementSibling);
      }
    };

    if (!window[stateKey]) {
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const schedulePlacement = () => window.requestAnimationFrame(placeCta);

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', schedulePlacement);
      } else {
        mobileQuery.addListener(schedulePlacement);
      }

      document.addEventListener('shopify:section:load', schedulePlacement);
      document.addEventListener('shopify:section:reorder', schedulePlacement);
      window[stateKey] = { placeCta };
    } else {
      window[stateKey].placeCta = placeCta;
    }

    window[stateKey].placeCta();
  })();

  function dedupePearhausReviewCards() {
    const section = document.querySelector("[id$='__178518690496d531ab']");
    if (!section) return;

    const seen = new Set();
    section.querySelectorAll('.jdgm-card').forEach((card) => {
      const copy = card.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const reviewCopy = (card.querySelector('.jdgm-card__review, .jdgm-card__body, .jdgm-rev__body')?.textContent || copy)
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const reviewer = (card.querySelector('.jdgm-card__name, .jdgm-rev__author')?.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const key = `${reviewer}|${reviewCopy}`;

      if (reviewCopy && seen.has(key)) {
        card.hidden = true;
      } else {
        card.hidden = false;
        seen.add(key);
      }
    });
  }

  dedupePearhausReviewCards();

  const pearhausReviewSection = document.querySelector("[id$='__178518690496d531ab']");
  if (pearhausReviewSection) {
    new MutationObserver(dedupePearhausReviewCards).observe(pearhausReviewSection, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-home-header"]) return;
  try {
    
  if (!customElements.get('pearhaus-home-header')) {
    customElements.define(
      'pearhaus-home-header',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-menu-dialog]');
          this.openButton = this.querySelector('[data-menu-open]');
          this.closeButton = this.querySelector('[data-menu-close]');

          this.openButton?.addEventListener('click', () => {
            this.dialog.showModal();
            this.openButton.setAttribute('aria-expanded', 'true');
          });

          this.closeButton?.addEventListener('click', () => this.dialog.close());
          this.querySelectorAll('[data-menu-link]').forEach((link) => {
            link.addEventListener('click', () => this.dialog.close());
          });

          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.dialog?.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
              event.preventDefault();
              this.dialog.close();
            }
          });

          this.dialog?.addEventListener('close', () => {
            this.openButton.setAttribute('aria-expanded', 'false');
            this.openButton.focus();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-home-routine"] && !Shopify.designMode) return;
  try {
    
  if (!window.pearhausProofVideosInitialized) {
    window.pearhausProofVideosInitialized = true;

    const pauseProofVideo = (video) => {
      video.pause();
      video.closest('.pearhaus-proof__media')?.classList.remove('is-playing');
    };

    document.addEventListener('click', (event) => {
      const playButton = event.target.closest('.pearhaus-proof__play');
      const clickedVideo = event.target.closest('.pearhaus-proof__video');

      if (playButton) {
        const media = playButton.closest('.pearhaus-proof__media');
        const video = media?.querySelector('.pearhaus-proof__video');
        if (!video) return;

        document.querySelectorAll('.pearhaus-proof__video').forEach((otherVideo) => {
          if (otherVideo !== video) pauseProofVideo(otherVideo);
        });

        video.play().then(() => media.classList.add('is-playing')).catch(() => {});
        return;
      }

      if (clickedVideo && !clickedVideo.paused) {
        pauseProofVideo(clickedVideo);
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !entry.target.paused) pauseProofVideo(entry.target);
        });
      }, { threshold: 0.25 });

      const observeProofVideos = () => {
        document.querySelectorAll('.pearhaus-proof__video').forEach((video) => observer.observe(video));
      };

      observeProofVideos();
      document.addEventListener('shopify:section:load', observeProofVideos);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-home-tested-trusted"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pauseVideo = (video) => {
      video.pause();
      const media = video.closest('.pearhaus-proof__media');
      const button = media?.querySelector('.pearhaus-proof__play');
      media?.classList.remove('is-playing');
      button?.setAttribute('aria-pressed', 'false');
      if (button) button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Pause', 'Play'));
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.pearhaus-proof__play');
      if (!button) return;

      const media = button.closest('.pearhaus-proof__media');
      const video = media?.querySelector('video');
      if (!video) return;

      document.querySelectorAll('.pearhaus-proof__video').forEach((otherVideo) => {
        if (otherVideo !== video) pauseVideo(otherVideo);
      });

      video.play();
      media.classList.add('is-playing');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Play', 'Pause'));
    });

    document.addEventListener('click', (event) => {
      const media = event.target.closest('.pearhaus-proof__media.is-playing');
      if (!media || event.target.closest('.pearhaus-proof__play')) return;
      const video = media.querySelector('video');
      if (video) pauseVideo(video);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !entry.target.paused) pauseVideo(entry.target);
      });
    }, { threshold: 0.35 });

    document.querySelectorAll('.pearhaus-proof__video').forEach((video) => observer.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-home-trending"] && !Shopify.designMode) return;
  try {
    
  class PearhausHomeTrending extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.track = this.querySelector('[data-trending-track]');
      this.track?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
    }

    move(direction) {
      const card = this.track?.querySelector('.pearhaus-home-card');
      if (!card) return;

      const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  }

  if (!customElements.get('pearhaus-home-trending')) {
    customElements.define('pearhaus-home-trending', PearhausHomeTrending);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-native-quiz"]) return;
  try {
    
  if (!customElements.get('pearhaus-native-quiz')) {
    customElements.define(
      'pearhaus-native-quiz',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.dialog = this.querySelector('[data-quiz-dialog]');
          this.form = this.querySelector('[data-quiz-form]');
          this.intro = this.querySelector('[data-quiz-intro]');
          this.progress = this.querySelector('[data-quiz-progress]');
          this.progressCurrent = this.querySelector('[data-quiz-progress-current]');
          this.progressTotal = this.querySelector('[data-quiz-progress-total]');
          this.steps = [...this.querySelectorAll('[data-quiz-step]')];
          this.actions = this.querySelector('[data-quiz-actions]');
          this.result = this.querySelector('[data-quiz-result]');
          this.error = this.querySelector('[data-quiz-error]');
          this.products = JSON.parse(this.querySelector('[data-quiz-products]').textContent);
          this.ogProductPromise = this.products.ogKit?.url
            ? Promise.resolve(this.products.ogKit)
            : this.loadProductFallback('first-time-set');
          if (this.progressTotal) this.progressTotal.textContent = String(this.steps.length);
          this.previousOverflow = '';
          this.currentStep = -1;
          this.returnFocus = null;
          this.advanceTimer = null;
          this.redirectTimer = null;
          this.redirectInterval = null;

          this.querySelector('[data-quiz-close]')?.addEventListener('click', () => this.close());
          this.querySelector('[data-quiz-start]')?.addEventListener('click', () => this.start());
          this.querySelector('[data-quiz-back]')?.addEventListener('click', () => this.back());
          this.querySelector('[data-quiz-next]')?.addEventListener('click', () => this.next());
          const scheduleAdvance = (event) => {
            const input = event.target.closest?.('.pearhaus-native-quiz__choice input[type="radio"]');
            if (!input) return;

            const stepIndex = this.steps.indexOf(input.closest('[data-quiz-step]'));
            if (stepIndex !== this.currentStep) return;

            window.clearTimeout(this.advanceTimer);
            this.advanceTimer = window.setTimeout(() => {
              if (this.currentStep === stepIndex && input.checked) this.next();
            }, 140);
          };
          this.form?.addEventListener('click', scheduleAdvance);
          this.form?.addEventListener('change', scheduleAdvance);
          this.dialog?.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.close();
          });
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog?.addEventListener('keydown', (event) => this.handleKeydown(event));
          this.dialog?.addEventListener('close', () => this.finishClose());

          this.onDocumentClick = (event) => {
            const link = event.target.closest?.('a[href]');
            if (!link || !/#quiz$/i.test(link.getAttribute('href') || '')) return;

            const destination = new URL(link.href, window.location.href);
            const isCurrentPage = destination.origin === window.location.origin
              && destination.pathname === window.location.pathname
              && destination.search === window.location.search;

            if (!isCurrentPage) return;
            event.preventDefault();
            if (window.location.hash.toLowerCase() !== '#quiz') {
              window.history.pushState({}, '', `${destination.pathname}${destination.search}#quiz`);
            }
            this.open(link);
          };
          document.addEventListener('click', this.onDocumentClick);
          this.onPopstate = () => {
            if (window.location.hash.toLowerCase() === '#quiz') {
              this.open();
            } else if (this.dialog?.open) {
              this.close(false);
            }
          };
          window.addEventListener('popstate', this.onPopstate);

          window.requestAnimationFrame(() => {
            if (window.location.hash.toLowerCase() === '#quiz') this.open();
          });
        }

        disconnectedCallback() {
          window.clearTimeout(this.advanceTimer);
          this.clearRedirect();
          document.removeEventListener('click', this.onDocumentClick);
          window.removeEventListener('popstate', this.onPopstate);
        }

        open(trigger) {
          if (!this.dialog || this.dialog.open) return;
          this.returnFocus = trigger || document.activeElement;
          this.reset();
          this.dialog.showModal();
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.querySelector('[data-quiz-start]')?.focus();
        }

        close(removeHash = true) {
          if (!this.dialog?.open) return;
          this.clearRedirect();
          this.dialog.close();
          if (removeHash && window.location.hash.toLowerCase() === '#quiz') {
            window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
          }
        }

        finishClose() {
          document.body.style.overflow = this.previousOverflow;
          const focusTarget = this.returnFocus;
          this.returnFocus = null;
          if (focusTarget && document.contains(focusTarget) && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
          }
        }

        handleKeydown(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')]
            .filter((element) => !element.closest('[hidden]'));
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        start() {
          this.showStep(0);
        }

        back() {
          window.clearTimeout(this.advanceTimer);
          this.clearError();
          if (this.currentStep <= 0) {
            this.showIntro();
          } else {
            this.showStep(this.currentStep - 1);
          }
        }

        next() {
          const step = this.steps[this.currentStep];
          if (!step || !step.querySelector('input:checked')) {
            this.error.hidden = false;
            step?.querySelector('input')?.focus();
            return;
          }
          this.clearError();
          if (this.currentStep === this.steps.length - 1) {
            this.showResult();
          } else {
            this.showStep(this.currentStep + 1);
          }
        }

        clearError() {
          this.error.hidden = true;
        }

        showIntro() {
          this.clearRedirect();
          this.currentStep = -1;
          this.intro.hidden = false;
          this.progress.hidden = true;
          this.actions.hidden = true;
          this.result.hidden = true;
          this.steps.forEach((step) => { step.hidden = true; });
          this.querySelector('[data-quiz-start]')?.focus();
        }

        showStep(stepIndex) {
          this.clearRedirect();
          this.currentStep = stepIndex;
          this.intro.hidden = true;
          this.progress.hidden = false;
          this.actions.hidden = false;
          this.result.hidden = true;
          this.steps.forEach((step, index) => { step.hidden = index !== stepIndex; });
          this.progressCurrent.textContent = String(stepIndex + 1);
          this.querySelector('[data-quiz-next]').textContent = stepIndex === this.steps.length - 1
            ? this.dataset.finishLabel
            : this.dataset.nextLabel;
          this.steps[stepIndex]?.querySelector('input:checked, input')?.focus();
        }

        async loadProductFallback(handle) {
          try {
            const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) throw new Error('Product request failed');

            const product = await response.json();
            return {
              handle: product.handle || handle,
              url: product.url || `/products/${handle}`,
              title: product.title || '',
              image: product.featured_image || '',
              variants: (product.variants || []).map((variant) => ({
                id: variant.id,
                title: variant.title,
                available: variant.available,
                image: variant.featured_image?.src || product.featured_image || '',
              })),
            };
          } catch (error) {
            return this.products.ogKit;
          }
        }

        async showResult() {
          const result = this.calculateResult();
          let product = result.system === 'cloudset'
            ? (result.length === 'short' ? this.products.cloudsetShorty : this.products.cloudsetClassic)
            : this.products.ogKit;
          if (result.system !== 'cloudset' && (!product?.url || !product?.variants?.length)) {
            product = await this.ogProductPromise;
            this.products.ogKit = product;
          }
          const variant = this.pickVariant(product, result.style);
          const image = variant?.image || product?.image || '';
          const productUrl = product?.url || '';
          const cta = this.querySelector('[data-quiz-cta]');
          const imageWrap = this.querySelector('[data-result-media]');
          const imageElement = this.querySelector('[data-result-image]');
          const fallback = this.querySelector('[data-quiz-fallback]');
          const redirect = this.querySelector('[data-result-redirect]');

          this.intro.hidden = true;
          this.progress.hidden = true;
          this.actions.hidden = true;
          this.steps.forEach((step) => { step.hidden = true; });
          this.result.hidden = false;
          this.querySelector('[data-result-product]').textContent = product?.title || '';
          this.querySelector('[data-result-system]').textContent = result.system === 'cloudset'
            ? this.dataset.systemCloudset
            : this.dataset.systemOg;
          this.querySelector('[data-result-length-row]').hidden = result.system !== 'cloudset';
          this.querySelector('[data-result-length]').textContent = result.length === 'short'
            ? this.dataset.lengthShorty
            : this.dataset.lengthClassic;
          this.querySelector('[data-result-style]').textContent = this.dataset[`style${result.style[0].toUpperCase()}${result.style.slice(1)}`] || result.style;
          this.querySelector('[data-result-rationale]').textContent = this.dataset[`rationale${result.look[0].toUpperCase()}${result.look.slice(1)}`] || '';

          if (image) {
            imageElement.src = image;
            imageElement.alt = product?.title || '';
            imageWrap.hidden = false;
          } else {
            imageElement.removeAttribute('src');
            imageWrap.hidden = true;
          }

          const destination = productUrl
            ? (variant?.id ? this.variantUrl(productUrl, variant.id) : productUrl)
            : '';

          if (destination) {
            cta.href = destination;
            cta.textContent = this.dataset.ctaLabel || 'Shop my match';
            cta.hidden = false;
            cta.removeAttribute('aria-disabled');
            fallback.hidden = true;
            redirect.hidden = false;
            this.startRedirect(destination);
          } else {
            this.clearRedirect();
            cta.href = this.dataset.fallbackUrl || '/collections/new-shop-all';
            cta.textContent = this.dataset.fallbackCtaLabel || 'Shop all';
            cta.hidden = false;
            cta.removeAttribute('aria-disabled');
            fallback.textContent = this.dataset.fallback || '';
            fallback.hidden = false;
            redirect.hidden = true;
          }
          cta.focus();
        }

        clearRedirect() {
          window.clearTimeout(this.redirectTimer);
          window.clearInterval(this.redirectInterval);
          this.redirectTimer = null;
          this.redirectInterval = null;
        }

        startRedirect(destination) {
          this.clearRedirect();
          const redirect = this.querySelector('[data-result-redirect]');
          if (!redirect || !destination) return;

          let remaining = Math.max(1, Number.parseInt(this.dataset.redirectSeconds || '5', 10) || 5);
          const renderCountdown = () => {
            const unit = remaining === 1 ? 'second' : 'seconds';
            redirect.innerHTML = `${this.dataset.redirectMessage || 'Taking you to your product page in'} <strong>${remaining}</strong> ${unit}&hellip;`;
          };

          renderCountdown();
          this.redirectInterval = window.setInterval(() => {
            remaining -= 1;
            if (remaining > 0) renderCountdown();
          }, 1000);
          this.redirectTimer = window.setTimeout(() => {
            this.clearRedirect();
            window.location.assign(destination);
          }, remaining * 1000);
        }

        calculateResult() {
          const answer = (name) => this.form.querySelector(`input[name="${name}"]:checked`)?.value || '';
          const experience = answer('experience');
          const system = answer('system_preference');
          const length = answer('length');
          const look = answer('look');
          const eyelid = answer('eyelid');
          const angle = answer('angle');
          const occasion = answer('occasion');
          const styleScores = { sandy: 0, tiffany: 0, tahlia: 0, kyra: 0 };

          const baseStyle = {
            soft: 'tahlia',
            wispy: 'sandy',
            bold: 'kyra',
          }[look] || 'sandy';
          styleScores[baseStyle] += 4;
          if (eyelid === 'monolid') styleScores.tahlia += 2;
          if (eyelid === 'hooded') styleScores.tiffany += 2;
          if (eyelid === 'crease') styleScores.kyra += 2;
          if (angle === 'straight') styleScores.tahlia += 2;
          if (angle === 'upturned') styleScores.sandy += 2;
          if (angle === 'downturned') styleScores.tiffany += 2;
          if (occasion === 'weekends') styleScores.tahlia += 2;
          if (occasion === 'vacations') styleScores.tiffany += 2;
          if (occasion === 'weddings') styleScores.kyra += 2;
          if (occasion === 'everyday') styleScores.sandy += 2;

          const stableStyleOrder = ['sandy', 'tiffany', 'tahlia', 'kyra'];
          const highestScore = Math.max(...Object.values(styleScores));
          const style = styleScores[baseStyle] === highestScore
            ? baseStyle
            : stableStyleOrder.find((key) => styleScores[key] === highestScore) || baseStyle;
          return {
            experience,
            system: system === 'og' ? 'og' : 'cloudset',
            length,
            look,
            style: system === 'og' && style === 'sandy' ? 'tiffany' : style,
          };
        }

        variantUrl(productUrl, variantId) {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('variant', String(variantId));
          url.searchParams.set('quiz', '1');
          return `${url.pathname}${url.search}${url.hash}`;
        }

        pickVariant(product, style) {
          if (!product?.variants?.length) return null;
          const normalizedStyle = style.toLowerCase();
          const available = product.variants.filter((variant) => variant.available);
          const matchingAvailable = available.find((variant) => variant.title.toLowerCase().includes(normalizedStyle));
          const matching = product.variants.find((variant) => variant.title.toLowerCase().includes(normalizedStyle));
          return matchingAvailable || matching || available[0] || product.variants[0];
        }

        reset() {
          window.clearTimeout(this.advanceTimer);
          this.clearRedirect();
          this.form.reset();
          this.clearError();
          this.showIntro();
        }

      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearhaus-product-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pearhaus-product-builder')) {
    customElements.define('pearhaus-product-builder', class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.catalog = JSON.parse(this.querySelector('[data-builder-catalog]').textContent);
        this.rootUrl = this.dataset.rootUrl || '/';
        this.maxRefills = Number(this.dataset.maxRefills) || 5;
        this.fixedAdditionalStyles = Number(this.dataset.fixedAdditionalStyles) || 0;
        this.fixedBundlePrice = Number(this.dataset.fixedBundlePrice) || 0;
        this.fixedBundleComparePrice = Number(this.dataset.fixedBundleComparePrice) || 0;
        this.wearsPerTray = Number(this.dataset.wearsPerTray) || 18;
        this.isUltimateOffer = this.fixedAdditionalStyles > 0;
        this.isMetaLanding = this.dataset.metaLanding === 'true';
        this.stockUpEnabled = !this.isMetaLanding && this.dataset.stockUpEnabled === 'true';
        this.bundleQuantity = 1;
        this.selectedKitKey = this.dataset.defaultKitKey;
        this.mainVariantId = null;
        this.freeGiftVariantId = this.querySelector('[data-meta-gift-choice]:checked')?.value || null;
        this.includeMainInMix = true;
        this.additionalKitQuantities = new Map();
        this.refillQuantities = new Map();
        this.addStyles = false;
        this.mode = 'one-time';
        this.cadence = '60';
        this.isQuizReferral = new URLSearchParams(window.location.search).get('quiz') === '1';
        this.showAlternativeStyles = false;
        this.quizRecommendation = null;
        this.mobileBuilderMedia = window.matchMedia('(max-width: 749px)');
        this.handleBuilderBreakpoint = () => this.render();
        this.mobileBuilderMedia.addEventListener('change', this.handleBuilderBreakpoint);
        await this.hydrateMissingKitProducts();
        this.bindEvents();
        this.preselectFromUrl();
        this.render();
        this.setupMetaEnhancements();
      }

      disconnectedCallback() {
        this.mobileBuilderMedia?.removeEventListener('change', this.handleBuilderBreakpoint);
        window.removeEventListener('scroll', this.handleMetaStickyScroll);
        window.removeEventListener('resize', this.handleMetaStickyScroll);
        if (this.metaStickyFrame) window.cancelAnimationFrame(this.metaStickyFrame);
        if (this.metaReviewTimer) window.clearTimeout(this.metaReviewTimer);
      }

      setupMetaEnhancements() {
        if (!this.isMetaLanding) return;
        const stickyButton = this.querySelector('[data-meta-sticky-add]');
        const reviewButton = this.querySelector('[data-meta-review-proof]');
        stickyButton?.addEventListener('click', () => {
          const mainButton = this.querySelector('[data-add-to-cart]');
          if (!mainButton || mainButton.disabled) return;
          stickyButton.disabled = true;
          mainButton.click();
        });
        reviewButton?.addEventListener('click', () => {
          const reviews = document.querySelector('.jdgm-cards-carousel, .jdgm-review-widget, [data-widget="cards-carousel"]');
          if (!reviews) return;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          reviews.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
        this.handleMetaStickyScroll = () => {
          if (this.metaStickyFrame) return;
          this.metaStickyFrame = window.requestAnimationFrame(() => {
            this.metaStickyFrame = null;
            this.syncMetaEnhancements();
          });
        };
        window.addEventListener('scroll', this.handleMetaStickyScroll, { passive: true });
        window.addEventListener('resize', this.handleMetaStickyScroll, { passive: true });
        this.syncMetaReviewProof();
        this.syncMetaEnhancements();
      }

      syncMetaReviewProof(attempt = 0) {
        if (!this.isMetaLanding) return;
        const source = document.querySelector('.jdgm-average-rating');
        const sourceText = source?.querySelector('.jdgm-rating-text')?.textContent?.trim() || '';
        const rating = sourceText.match(/[0-9]+(?:\.[0-9]+)?/)?.[0];
        const count = source?.querySelector('.jdgm-reviews-count')?.textContent?.trim();
        const proof = this.querySelector('[data-meta-review-proof]');
        if (proof && rating && count) {
          proof.querySelector('[data-meta-review-stars]').textContent = '★★★★★';
          proof.querySelector('[data-meta-review-text]').textContent = `${rating} (${count} reviews)`;
          proof.setAttribute('aria-label', `${rating} out of 5 from ${count} reviews. Read reviews.`);
          proof.hidden = false;
          return;
        }
        if (attempt >= 20) return;
        this.metaReviewTimer = window.setTimeout(() => this.syncMetaReviewProof(attempt + 1), 250);
      }

      syncMetaEnhancements() {
        if (!this.isMetaLanding) return;
        const mainButton = this.querySelector('[data-add-to-cart]');
        const sticky = this.querySelector('[data-meta-sticky]');
        const stickyButton = this.querySelector('[data-meta-sticky-add]');
        const stickySelection = this.querySelector('[data-meta-sticky-selection]');
        if (stickyButton && mainButton) stickyButton.disabled = mainButton.disabled;
        if (stickySelection) stickySelection.textContent = this.querySelector('[data-meta-current-label]')?.textContent?.trim() || this.mainVariant()?.title || '';
        if (sticky && mainButton) sticky.hidden = !(this.mobileBuilderMedia.matches && mainButton.getBoundingClientRect().bottom < 0);
      }

      async hydrateMissingKitProducts() {
        const fallbackHandles = {
          'classic-cloudset': 'classic-cloudset',
          'shorty-cloudset': 'shorty-cloudset',
          og: 'first-time-set'
        };
        const missingKits = this.catalog.kits.filter((kit) => !kit.variants.length && fallbackHandles[kit.key]);

        await Promise.all(missingKits.map(async (kit) => {
          try {
            const handle = fallbackHandles[kit.key];
            const response = await fetch(`/products/${handle}.js`, {
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) return;

            const product = await response.json();
            const plans = new Map(
              (product.selling_plan_groups || [])
                .flatMap((group) => group.selling_plans || [])
                .map((plan) => [String(plan.id), plan])
            );

            kit.title = product.title || kit.label;
            kit.description = product.description || kit.description || '';
            kit.variants = (product.variants || []).map((variant) => {
              const media = variant.featured_media?.preview_image || variant.featured_image || product.featured_image;
              return {
                id: variant.id,
                title: variant.title,
                available: Boolean(variant.available),
                price: Number(variant.price) || 0,
                image: typeof media === 'string' ? media : media?.src || '',
                alt: variant.featured_media?.alt || variant.title || product.title || '',
                allocations: (variant.selling_plan_allocations || []).map((allocation) => {
                  const plan = plans.get(String(allocation.selling_plan_id));
                  return {
                    id: allocation.selling_plan_id,
                    price: allocation.price,
                    name: plan?.name || '',
                    options: (plan?.options || []).map((option) => option.value || option)
                  };
                })
              };
            });
            this.appendHydratedKitControls(kit);
          } catch (error) {
            console.warn(`Pearhaus builder could not load ${kit.key}.`, error);
          }
        }));
      }

      appendHydratedKitControls(kit) {
        const styleList = this.querySelector(`[data-kit-style-list][data-kit-key="${kit.key}"]`);
        const additionalList = this.querySelector('[data-additional-kits-fieldset] .pearhaus-product-builder__additional-kit-list');
        const selectLabel = this.querySelector('[data-main-style-choice]')?.closest('label')?.querySelector('strong')?.textContent || 'Select';

        kit.variants.forEach((variant) => {
          if (styleList && !styleList.querySelector(`[data-variant-id="${variant.id}"]`)) {
            const row = document.createElement('article');
            row.className = 'pearhaus-product-builder__variant';
            row.dataset.kitVariantRow = '';
            row.dataset.kitKey = kit.key;
            row.dataset.variantId = String(variant.id);
            row.dataset.available = String(variant.available);

            const media = document.createElement('div');
            media.className = 'pearhaus-product-builder__variant-image';
            if (variant.image) {
              const image = document.createElement('img');
              image.src = variant.image;
              image.alt = '';
              image.width = 88;
              image.height = 88;
              image.loading = 'lazy';
              media.append(image);
            }

            const copy = document.createElement('div');
            copy.className = 'pearhaus-product-builder__variant-copy';
            const title = document.createElement('h3');
            title.textContent = variant.title;
            const status = document.createElement('p');
            status.dataset.variantStatus = '';
            status.textContent = variant.available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
            copy.append(title, status);

            const choice = document.createElement('label');
            choice.className = 'pearhaus-product-builder__single-choice';
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = `main-style-${this.id}`;
            input.value = String(variant.id);
            input.dataset.mainStyleChoice = '';
            input.disabled = !variant.available;
            const indicator = document.createElement('span');
            indicator.setAttribute('aria-hidden', 'true');
            const choiceText = document.createElement('strong');
            choiceText.textContent = selectLabel;
            choice.append(input, indicator, choiceText);
            row.append(media, copy, choice);
            styleList.append(row);
          }

          if (additionalList && !additionalList.querySelector(`[data-additional-kit-row][data-variant-id="${variant.id}"]`)) {
            const row = document.createElement('article');
            row.className = 'pearhaus-product-builder__variant';
            row.dataset.additionalKitRow = '';
            row.dataset.variantId = String(variant.id);
            row.dataset.available = String(variant.available);

            const media = document.createElement('div');
            media.className = 'pearhaus-product-builder__variant-image';
            if (variant.image) {
              const image = document.createElement('img');
              image.src = variant.image;
              image.alt = '';
              image.width = 88;
              image.height = 88;
              image.loading = 'lazy';
              media.append(image);
            }

            const copy = document.createElement('div');
            copy.className = 'pearhaus-product-builder__variant-copy';
            const title = document.createElement('h3');
            title.textContent = variant.title;
            const status = document.createElement('p');
            status.textContent = variant.available ? kit.label : this.dataset.soldOutLabel;
            const primaryLabel = document.createElement('span');
            primaryLabel.className = 'pearhaus-product-builder__primary-set-label';
            primaryLabel.dataset.primarySetLabel = '';
            primaryLabel.hidden = true;
            primaryLabel.textContent = 'Included as your first set';
            copy.append(title, status, primaryLabel);

            const quantity = document.createElement('div');
            quantity.className = 'pearhaus-product-builder__quantity-control';
            quantity.setAttribute('aria-label', `${variant.title} quantity`);
            const decrease = document.createElement('button');
            decrease.type = 'button';
            decrease.dataset.additionalKitDecrease = '';
            decrease.setAttribute('aria-label', `Remove one ${variant.title}`);
            decrease.disabled = true;
            decrease.textContent = '-';
            const output = document.createElement('output');
            output.dataset.additionalKitQuantity = '';
            output.setAttribute('aria-live', 'polite');
            output.textContent = '0';
            const increase = document.createElement('button');
            increase.type = 'button';
            increase.dataset.additionalKitIncrease = '';
            increase.setAttribute('aria-label', `Add one ${variant.title}`);
            increase.disabled = !variant.available;
            increase.textContent = '+';
            quantity.append(decrease, output, increase);
            row.append(media, copy, quantity);
            additionalList.append(row);
          }
        });
      }

      bindEvents() {
        this.querySelectorAll('[data-kit-choice]').forEach((input) => input.addEventListener('change', () => { this.selectedKitKey = input.value; this.mainVariantId = null; this.includeMainInMix = true; this.trimAdditionalKitQuantities(); this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-main-style-choice]').forEach((input) => input.addEventListener('change', () => { this.mainVariantId = String(input.value); this.includeMainInMix = true; this.trimAdditionalKitQuantities(); this.clearMessage(); this.render(); if (this.isMetaLanding) this.querySelector('[data-meta-options]')?.removeAttribute('open'); }));
        this.querySelectorAll('[data-meta-gift-choice]').forEach((input) => input.addEventListener('change', () => { this.freeGiftVariantId = String(input.value); this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-bundle-quantity]').forEach((input) => input.addEventListener('change', () => {
          this.bundleQuantity = Number(input.value) || 1;
          if (this.bundleQuantity === 1) this.includeMainInMix = true;
          this.trimAdditionalKitQuantities();
          this.clearMessage();
          this.render();
          if (this.mobileBuilderMedia.matches && this.bundleQuantity > 1) window.requestAnimationFrame(() => this.scrollToAdditionalSets());
        }));
        this.querySelectorAll('[data-additional-kit-increase]').forEach((button) => button.addEventListener('click', () => this.adjustAdditionalKitQuantity(button.closest('[data-additional-kit-row]')?.dataset.variantId, 1)));
        this.querySelectorAll('[data-additional-kit-decrease]').forEach((button) => button.addEventListener('click', () => this.adjustAdditionalKitQuantity(button.closest('[data-additional-kit-row]')?.dataset.variantId, -1)));
        this.querySelectorAll('[data-add-styles-mode]').forEach((input) => input.addEventListener('change', () => { this.addStyles = input.value === 'yes'; if (!this.addStyles) this.refillQuantities.clear(); this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-purchase-mode]').forEach((input) => input.addEventListener('change', () => { this.mode = input.value; this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-cadence]').forEach((button) => button.addEventListener('click', () => { this.cadence = button.dataset.cadence; this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-refill-choice]').forEach((input) => input.addEventListener('change', () => { if (input.checked) this.refillQuantities.set(String(input.value), 1); else this.refillQuantities.delete(String(input.value)); this.clearMessage(); this.render(); }));
        this.querySelectorAll('[data-refill-increase]').forEach((button) => button.addEventListener('click', () => this.adjustRefillQuantity(button.closest('[data-refill-row]')?.dataset.variantId, 1)));
        this.querySelectorAll('[data-refill-decrease]').forEach((button) => button.addEventListener('click', () => this.adjustRefillQuantity(button.closest('[data-refill-row]')?.dataset.variantId, -1)));
        this.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => button.addEventListener('click', () => this.selectGalleryImage(button, { scrollThumbnail: true })));
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.navigateGallery(-1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.navigateGallery(1));
        this.querySelector('[data-gallery-main]')?.addEventListener('keydown', (event) => this.handleGalleryKeydown(event));
        this.querySelectorAll('[data-gallery-set]').forEach((set) => set.addEventListener('keydown', (event) => this.handleGalleryKeydown(event)));
        const galleryMain = this.querySelector('[data-gallery-main]');
        galleryMain?.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button')) return;
          this.galleryPointerStart = { x: event.clientX, y: event.clientY };
        });
        galleryMain?.addEventListener('pointerup', (event) => {
          if (!this.galleryPointerStart || event.target.closest('button')) return;
          const deltaX = event.clientX - this.galleryPointerStart.x;
          const deltaY = event.clientY - this.galleryPointerStart.y;
          this.galleryPointerStart = null;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          this.navigateGallery(deltaX < 0 ? 1 : -1);
        });
        galleryMain?.addEventListener('pointercancel', () => { this.galleryPointerStart = null; });
        this.querySelector('[data-quiz-show-alternatives]')?.addEventListener('click', () => {
          const closingAlternatives = this.showAlternativeStyles;
          this.showAlternativeStyles = !this.showAlternativeStyles;
          if (closingAlternatives && this.quizRecommendation) {
            this.selectedKitKey = this.quizRecommendation.kitKey;
            this.mainVariantId = String(this.quizRecommendation.id);
            this.render();
            return;
          }
          this.renderQuizRecommendation();
        });
        this.querySelector('[data-add-to-cart]')?.addEventListener('click', () => this.addToCart());
      }

      allKitVariants() { return this.catalog.kits.flatMap((kit) => kit.variants.map((variant) => ({ ...variant, kitKey: kit.key, kitLabel: kit.label, systemKey: kit.systemKey, systemLabel: kit.systemLabel }))); }
      kit() { return this.catalog.kits.find((item) => item.key === this.selectedKitKey) || this.catalog.kits[0]; }
      mainVariant() { return this.kit()?.variants.find((item) => String(item.id) === String(this.mainVariantId)); }
      additionalKitQuantity(variantId) { return Number(this.additionalKitQuantities.get(String(variantId))) || 0; }
      totalAdditionalKitQuantity() { return [...this.additionalKitQuantities.values()].reduce((total, quantity) => total + Number(quantity || 0), 0); }
      requiredAdditionalKitQuantity() { return Math.max(0, this.bundleQuantity - (this.includeMainInMix ? 1 : 0)); }
      regularMixComplete() { return this.isUltimateOffer || this.totalAdditionalKitQuantity() === this.requiredAdditionalKitQuantity(); }
      refillVariants() { return this.catalog.refills.flatMap((product) => product.variants.map((variant) => ({ ...variant, productKey: product.key, productTitle: product.title, systemKey: product.systemKey }))); }
      refillQuantity(variantId) { return Number(this.refillQuantities.get(String(variantId))) || 0; }
      totalRefillQuantity() { return [...this.refillQuantities.values()].reduce((total, quantity) => total + Number(quantity || 0), 0); }
      freeGiftSelection() { return this.querySelector(`[data-meta-gift-choice][value="${this.freeGiftVariantId}"]`); }
      selectedItems() {
        const main = this.mainVariant();
        const additions = this.isUltimateOffer ? [] : this.allKitVariants().filter((variant) => this.additionalKitQuantity(variant.id) > 0).map((variant) => ({ ...variant, quantity: this.additionalKitQuantity(variant.id) }));
        const refills = this.isUltimateOffer && this.addStyles ? this.refillVariants().filter((variant) => this.refillQuantity(variant.id) > 0).map((variant) => ({ ...variant, quantity: this.refillQuantity(variant.id) })) : [];
        const merged = new Map();
        [main && this.includeMainInMix ? { ...main, quantity: 1 } : null, ...additions, ...refills].filter(Boolean).forEach((variant) => {
          const key = String(variant.id);
          const existing = merged.get(key);
          merged.set(key, existing ? { ...existing, quantity: Number(existing.quantity) + Number(variant.quantity || 1) } : variant);
        });
        return [...merged.values()];
      }

      adjustAdditionalKitQuantity(variantId, delta) {
        if (!variantId) return;
        const variant = this.allKitVariants().find((item) => String(item.id) === String(variantId));
        if (!variant?.available) return;
        const wasComplete = this.regularMixComplete();
        const current = this.additionalKitQuantity(variantId);
        const isMainVariant = String(variantId) === String(this.mainVariantId);
        if (isMainVariant && delta < 0 && this.includeMainInMix && current === 0) {
          this.includeMainInMix = false;
          this.clearMessage();
          this.render();
          return;
        }
        if (isMainVariant && delta > 0 && !this.includeMainInMix) {
          this.includeMainInMix = true;
          this.trimAdditionalKitQuantities();
          this.clearMessage();
          this.render();
          return;
        }
        if (delta > 0 && this.totalAdditionalKitQuantity() >= this.requiredAdditionalKitQuantity()) return;
        const next = Math.max(0, current + delta);
        if (next) this.additionalKitQuantities.set(String(variantId), next); else this.additionalKitQuantities.delete(String(variantId));
        this.clearMessage();
        this.render();
        if (delta > 0 && !wasComplete && this.regularMixComplete() && this.mobileBuilderMedia.matches) {
          window.requestAnimationFrame(() => this.scrollToCompletedOffer());
        }
      }

      syncOfferSummaryPlacement() {
        const summary = this.querySelector('[data-offer-summary]');
        const anchor = this.querySelector('[data-offer-summary-anchor]');
        const additionalFieldset = this.querySelector('[data-additional-kits-fieldset]');
        if (!summary || !anchor) return;
        if (this.mobileBuilderMedia?.matches && this.bundleQuantity > 1 && this.regularMixComplete() && additionalFieldset) additionalFieldset.after(summary);
        else anchor.after(summary);
      }

      scrollToCompletedOffer() {
        const summary = this.querySelector('[data-offer-summary]');
        if (!summary || summary.hidden) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        summary.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }

      scrollToAdditionalSets() {
        const additionalFieldset = this.querySelector('[data-additional-kits-fieldset]');
        if (!additionalFieldset || additionalFieldset.hidden) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        additionalFieldset.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }

      trimAdditionalKitQuantities() {
        let excess = this.totalAdditionalKitQuantity() - this.requiredAdditionalKitQuantity();
        if (excess <= 0) return;
        [...this.additionalKitQuantities.entries()].reverse().forEach(([variantId, quantity]) => {
          if (excess <= 0) return;
          const remove = Math.min(Number(quantity), excess);
          const next = Number(quantity) - remove;
          if (next) this.additionalKitQuantities.set(variantId, next); else this.additionalKitQuantities.delete(variantId);
          excess -= remove;
        });
      }

      adjustRefillQuantity(variantId, delta) {
        if (!variantId) return;
        const current = this.refillQuantity(variantId);
        if (delta > 0 && this.totalRefillQuantity() >= this.maxRefills) return;
        const next = Math.max(0, Math.min(this.maxRefills, current + delta));
        if (next) this.refillQuantities.set(String(variantId), next); else this.refillQuantities.delete(String(variantId));
        this.clearMessage();
        this.render();
      }

      preselectFromUrl() {
        const queryVariant = new URLSearchParams(window.location.search).get('variant');
        const queryMatch = queryVariant && this.allKitVariants().find((variant) => String(variant.id) === String(queryVariant));
        const defaultMatch = this.isMetaLanding && this.allKitVariants().find((variant) => String(variant.id) === String(this.dataset.defaultVariantId));
        const match = queryMatch || defaultMatch;
        if (match && match.available) {
          this.selectedKitKey = match.kitKey;
          this.mainVariantId = String(match.id);
          if (this.isQuizReferral) this.quizRecommendation = { ...match };
          return;
        }
        this.isQuizReferral = false;
        const selectedKit = this.kit();
        this.mainVariantId = String(selectedKit?.variants.find((variant) => variant.available)?.id || '');
      }

      renderQuizRecommendation() {
        const panel = this.querySelector('[data-quiz-recommendation]');
        const button = this.querySelector('[data-quiz-show-alternatives]');
        const recommendation = this.quizRecommendation;
        const showRecommendation = Boolean(this.isQuizReferral && recommendation);

        if (panel) panel.hidden = !showRecommendation;
        this.querySelectorAll('[data-quiz-alternative-control]').forEach((control) => {
          control.hidden = showRecommendation && !this.showAlternativeStyles;
        });
        this.toggleAttribute('data-quiz-recommendation-active', showRecommendation && !this.showAlternativeStyles);
        if (!showRecommendation) return;

        const image = this.querySelector('[data-quiz-recommendation-image]');
        const media = this.querySelector('[data-quiz-recommendation-media]');
        if (image && media) {
          media.hidden = !recommendation.image;
          if (recommendation.image) {
            image.src = recommendation.image;
            image.alt = recommendation.alt || recommendation.title || '';
          }
        }
        this.querySelector('[data-quiz-recommendation-style]').textContent = recommendation.title || '';
        this.querySelector('[data-quiz-recommendation-kit]').textContent = recommendation.kitLabel || recommendation.systemLabel || '';
        if (button) {
          button.setAttribute('aria-expanded', String(this.showAlternativeStyles));
          button.textContent = this.showAlternativeStyles ? this.dataset.quizHideStyleLabel : this.dataset.quizChangeStyleLabel;
        }
      }

      normalizeGalleryLabel(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      activeGallerySet() {
        return this.querySelector(`[data-gallery-set][data-kit-key="${CSS.escape(this.selectedKitKey)}"]`);
      }

      visibleGalleryThumbnails() {
        return [...(this.activeGallerySet()?.querySelectorAll('[data-gallery-thumbnail]') || [])].filter((button) => !button.hidden);
      }

      selectGalleryImage(button, options = {}) {
        const image = this.querySelector('[data-gallery-image]');
        if (!image) return;
        image.src = button.dataset.gallerySrc;
        image.alt = button.dataset.galleryAlt || '';
        image.dataset.galleryFit = button.dataset.galleryFit || 'contain';
        button.closest('[data-gallery-set]')?.querySelectorAll('[data-gallery-thumbnail]').forEach((thumbnail) => { const selected = thumbnail === button; thumbnail.classList.toggle('is-active', selected); thumbnail.setAttribute('aria-pressed', String(selected)); });
        if (options.scrollThumbnail) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        this.updateGalleryControls();
      }

      syncGalleryForVariant(kit, variant) {
        const set = this.activeGallerySet();
        if (!set || !variant) return;
        const shouldFilter = set.dataset.styleFilter === 'true' || this.isQuizReferral;
        const variantLabel = this.normalizeGalleryLabel(variant.title);
        const variantImagePath = variant.image ? new URL(variant.image, window.location.origin).pathname : '';
        const thumbnails = [...set.querySelectorAll('[data-gallery-thumbnail]')];
        thumbnails.forEach((button) => {
          const mediaLabel = this.normalizeGalleryLabel(button.dataset.galleryMediaAlt);
          const mediaPath = new URL(button.dataset.gallerySrc, window.location.origin).pathname;
          const matchesStyle = Boolean(mediaLabel && mediaLabel === variantLabel);
          const matchesFeaturedImage = Boolean(variantImagePath && mediaPath === variantImagePath);
          button.hidden = shouldFilter && !matchesStyle && !matchesFeaturedImage;
          if (button.hidden) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          }
        });

        const visible = this.visibleGalleryThumbnails();
        const metaHero = this.isMetaLanding && String(variant.id) === String(this.dataset.defaultVariantId)
          ? visible.find((button) => new URL(button.dataset.gallerySrc, window.location.origin).pathname.endsWith(`/${this.dataset.metaHeroFilename}`))
          : null;
        const featured = visible.find((button) => new URL(button.dataset.gallerySrc, window.location.origin).pathname === variantImagePath);
        const selected = visible.find((button) => button.classList.contains('is-active'));
        const target = metaHero || featured || selected || visible[0];
        if (target) {
          this.selectGalleryImage(target);
        } else {
          const image = this.querySelector('[data-gallery-image]');
          if (image && variant.image) {
            image.src = variant.image;
            image.alt = variant.alt || variant.title || kit.title;
          }
          this.updateGalleryControls();
        }
      }

      updateGalleryControls() {
        const thumbnails = this.visibleGalleryThumbnails();
        const current = thumbnails.findIndex((button) => button.classList.contains('is-active'));
        const previous = this.querySelector('[data-gallery-previous]');
        const next = this.querySelector('[data-gallery-next]');
        const count = this.querySelector('[data-gallery-count]');
        const hasMultiple = thumbnails.length > 1;
        if (previous) { previous.hidden = !hasMultiple; previous.disabled = current <= 0; }
        if (next) { next.hidden = !hasMultiple; next.disabled = current < 0 || current >= thumbnails.length - 1; }
        if (count) count.textContent = thumbnails.length ? `${Math.max(0, current) + 1} / ${thumbnails.length}` : '1 / 1';
      }

      navigateGallery(direction) {
        const thumbnails = this.visibleGalleryThumbnails();
        if (thumbnails.length < 2) return;
        const current = thumbnails.findIndex((button) => button.classList.contains('is-active'));
        const targetIndex = Math.min(thumbnails.length - 1, Math.max(0, (current < 0 ? 0 : current) + direction));
        if (targetIndex === current) return;
        this.selectGalleryImage(thumbnails[targetIndex], { scrollThumbnail: true });
      }

      handleGalleryKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        event.preventDefault();
        this.navigateGallery(event.key === 'ArrowRight' ? 1 : -1);
      }

      normalizeCadence(allocation) {
        const text = [allocation?.name, ...(allocation?.options || [])].join(' ').toLowerCase();
        if (/60|2\s*month|bi[- ]?monthly|every other month/.test(text)) return '60';
        if (/30|monthly|month/.test(text)) return '30';
        return '';
      }

      allocation(variant, cadence = this.cadence) { return variant?.allocations?.find((item) => this.normalizeCadence(item) === cadence); }
      canSubscribe(cadence) { const items = this.selectedItems(); return items.length > 0 && items.every((variant) => Boolean(this.allocation(variant, cadence))); }
      tierPercent() { if (this.isUltimateOffer) { if (!this.addStyles || this.totalRefillQuantity() !== this.fixedAdditionalStyles) return 0; if (this.fixedBundlePrice && this.fixedBundleComparePrice) return Math.round((1 - this.fixedBundlePrice / this.fixedBundleComparePrice) * 100); return Number(this.dataset.tierFour) || 15; } if (!this.regularMixComplete()) return 0; if (this.bundleQuantity >= 3) return Number(this.dataset.tierThree) || 15; if (this.bundleQuantity === 2) return Number(this.dataset.tierTwo) || 10; return 0; }
      basePrice(mode = this.mode, cadence = this.cadence) { return this.selectedItems().reduce((total, variant) => total + Number(mode === 'subscription' ? this.allocation(variant, cadence)?.price || 0 : variant.price || 0) * Number(variant.quantity || 1), 0); }
      sharedUnitPrice(mode = this.mode, cadence = this.cadence) {
        if (!this.isUltimateOffer && !this.stockUpEnabled && this.bundleQuantity === 1) {
          const variant = this.mainVariant();
          return Number(mode === 'subscription' ? this.allocation(variant, cadence)?.price || 0 : variant?.price || 0);
        }
        return Number(mode === 'subscription' ? this.dataset.sharedSubscriptionPrice : this.dataset.sharedKitPrice) || 0;
      }
      sharedBundlePrice(mode = this.mode, cadence = this.cadence) {
        if (this.isUltimateOffer) return { base: null, total: null, savings: null };
        const unitPrice = this.sharedUnitPrice(mode, cadence);
        if (!unitPrice) return { base: null, total: null, savings: null };
        const quantity = Math.max(1, this.bundleQuantity);
        const tier = quantity >= 3 ? Number(this.dataset.tierThree) || 15 : quantity === 2 ? Number(this.dataset.tierTwo) || 10 : 0;
        const base = unitPrice * quantity;
        const total = Math.round(base * (1 - tier / 100));
        return { base, total, savings: base - total };
      }
      pricingMatchesSharedPrice(mode = this.mode, cadence = this.cadence) {
        if (this.isUltimateOffer || !this.stockUpEnabled) return true;
        const expected = this.sharedUnitPrice(mode, cadence);
        if (!expected) return false;
        return this.allKitVariants().filter((variant) => variant.available).every((variant) => Number(mode === 'subscription' ? this.allocation(variant, cadence)?.price || 0 : variant.price || 0) === expected);
      }
      priceState(mode = this.mode, cadence = this.cadence) {
        const items = this.selectedItems();
        if (!this.mainVariant()?.available || items.some((variant) => !variant.available)) return { base: null, total: null, savings: null };
        if (!this.regularMixComplete()) return { base: null, total: null, savings: null };
        if (mode === 'subscription' && !this.canSubscribe(cadence)) return { base: null, total: null, savings: null };
        if (this.addStyles && this.fixedAdditionalStyles && this.fixedBundlePrice) {
          const subscriptionMultiplier = mode === 'subscription' ? 0.9 : 1;
          const total = Math.round(this.fixedBundlePrice * subscriptionMultiplier);
          const base = this.fixedBundleComparePrice || this.basePrice(mode, cadence);
          return { base, total, savings: Math.max(0, base - total) };
        }
        if (!this.isUltimateOffer) return this.sharedBundlePrice(mode, cadence);
        const base = this.basePrice(mode, cadence);
        const total = Math.round(base * (1 - this.tierPercent() / 100));
        return { base, total, savings: base - total };
      }

      formatMoney(cents) { if (cents === null || cents === undefined || Number.isNaN(Number(cents))) return '--'; try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.dataset.currency || 'CAD' }).format(Number(cents) / 100); } catch (error) { return `${(Number(cents) / 100).toFixed(2)} ${this.dataset.currency || ''}`.trim(); } }
      hasValidSelection() { const refillQuantity = this.totalRefillQuantity(); const hasRequiredStyles = !this.isUltimateOffer || !this.addStyles || refillQuantity === this.fixedAdditionalStyles; const giftChoice = this.freeGiftSelection(); const hasGift = !this.isMetaLanding || Boolean(giftChoice && !giftChoice.disabled); return Boolean(this.mainVariant()?.available) && hasGift && this.regularMixComplete() && hasRequiredStyles && refillQuantity <= this.maxRefills && this.selectedItems().every((variant) => variant.available) && (this.mode !== 'subscription' || this.canSubscribe(this.cadence)) && this.pricingMatchesSharedPrice(); }

      render() {
        const kit = this.kit();
        if (!kit) return;
        if (this.isMetaLanding) {
          this.bundleQuantity = 1;
          this.addStyles = false;
          this.mode = 'one-time';
          this.additionalKitQuantities.clear();
          this.refillQuantities.clear();
        }
        if (!this.mainVariantId || !kit.variants.some((variant) => String(variant.id) === String(this.mainVariantId) && variant.available)) this.mainVariantId = String(kit.variants.find((variant) => variant.available)?.id || '');
        const canSubscribe30 = this.canSubscribe('30');
        const canSubscribe60 = this.canSubscribe('60');
        if (this.mode === 'subscription' && !this.canSubscribe(this.cadence)) {
          if (canSubscribe30) this.cadence = '30';
          else if (canSubscribe60) this.cadence = '60';
          else this.mode = 'one-time';
        }
        const selected = this.selectedItems();
        const prices = this.priceState();
        const oneTimePrice = this.priceState('one-time');
        const offerReady = this.hasValidSelection();
        const displayedPrices = this.isUltimateOffer ? prices : this.sharedBundlePrice();
        const displayedOneTimePrice = this.isUltimateOffer ? oneTimePrice : this.sharedBundlePrice('one-time');
        const percent = this.tierPercent();
        const totalTrays = selected.reduce((total, item) => total + Number(item.quantity || 1), 0);
        const wearTrayCount = this.isUltimateOffer && this.addStyles ? this.fixedAdditionalStyles + 1 : offerReady ? totalTrays : Math.max(1, this.bundleQuantity);
        this.querySelector('[data-builder-title]').textContent = kit.title;
        this.querySelector('[data-builder-description]').innerHTML = (kit.description || '').replaceAll('—', ', ').replace(/\s--\s/g, '. ');
        this.querySelector('[data-included-content]').innerHTML = kit.included || '';
        this.querySelector('[data-ingredients-content]').innerHTML = kit.ingredients || '';
        this.querySelector('[data-cost-per-wear]').textContent = displayedPrices.total === null ? '--' : this.formatMoney(displayedPrices.total / (wearTrayCount * this.wearsPerTray));
        this.querySelector('[data-total-price]').textContent = this.formatMoney(displayedPrices.total);
        const totalLabel = this.querySelector('[data-total-label]');
        if (totalLabel) totalLabel.textContent = totalLabel.dataset.finalLabel;
        const offerSummary = this.querySelector('[data-offer-summary]');
        if (offerSummary) offerSummary.hidden = displayedPrices.total === null;
        const purchaseType = this.querySelector('[data-purchase-type]');
        if (purchaseType) purchaseType.hidden = this.isMetaLanding || !offerReady;
        const regularValue = displayedOneTimePrice.base;
        const bundleSavings = regularValue === null || displayedOneTimePrice.total === null ? 0 : Math.max(0, regularValue - displayedOneTimePrice.total);
        const subscriptionSavings = this.mode === 'subscription' && prices.total !== null && oneTimePrice.total !== null ? Math.max(0, oneTimePrice.total - prices.total) : 0;
        const totalSavings = regularValue === null || prices.total === null ? 0 : Math.max(0, regularValue - prices.total);
        const updateSavingsLine = (selector, priceSelector, value, visible) => {
          const line = this.querySelector(selector);
          if (!line) return;
          line.hidden = !visible;
          const price = line.querySelector(priceSelector);
          if (price) price.textContent = visible ? this.formatMoney(value) : '';
        };
        updateSavingsLine('[data-bundle-savings]', '[data-bundle-savings-price]', bundleSavings, bundleSavings > 0);
        updateSavingsLine('[data-subscription-savings]', '[data-subscription-savings-price]', subscriptionSavings, subscriptionSavings > 0);
        updateSavingsLine('[data-total-savings]', '[data-total-savings-price]', totalSavings, bundleSavings > 0 && subscriptionSavings > 0);
        this.querySelectorAll('[data-volume-cost]').forEach((cost) => {
          const quantity = Number(cost.dataset.volumeQuantity) || 1;
          const tier = quantity >= 3 ? Number(this.dataset.tierThree) || 15 : quantity === 2 ? Number(this.dataset.tierTwo) || 10 : 0;
          const unitPrice = this.sharedUnitPrice();
          const selectedTierPrice = !this.isUltimateOffer && quantity === this.bundleQuantity && this.regularMixComplete() ? this.priceState().total : null;
          const tierTotal = selectedTierPrice ?? unitPrice * quantity * (1 - tier / 100);
          cost.textContent = `${this.formatMoney(tierTotal / (quantity * this.wearsPerTray))}/wear`;
        });
        const selectionStatus = this.querySelector('[data-selection-status]');
        if (selectionStatus) { const styleCount = totalTrays ? totalTrays - 1 : 0; const savingsStatus = percent ? ' · Ultimate Mix & Match savings applied' : ''; selectionStatus.textContent = `${styleCount} of ${this.fixedAdditionalStyles} lash styles selected${savingsStatus}.`; }
        this.querySelectorAll('[data-kit-choice-card]').forEach((card) => {
          const selected = card.dataset.kitKey === kit.key;
          card.classList.toggle('is-selected', selected);
          card.querySelector('[data-kit-choice]').checked = selected;
        });
        this.querySelectorAll('[data-kit-style-list]').forEach((list) => list.hidden = list.dataset.kitKey !== kit.key);
        this.querySelectorAll('[data-gallery-set]').forEach((set) => set.hidden = set.dataset.kitKey !== kit.key);
        this.querySelectorAll('[data-kit-variant-row]').forEach((row) => { const variant = kit.variants.find((item) => String(item.id) === row.dataset.variantId); row.hidden = row.dataset.kitKey !== kit.key; const input = row.querySelector('[data-main-style-choice]'); if (input) input.checked = String(this.mainVariantId) === row.dataset.variantId; row.querySelector('[data-variant-status]').textContent = variant?.available ? this.dataset.availableLabel : this.dataset.soldOutLabel; });
        if (this.isMetaLanding) {
          const selectedVariant = this.mainVariant();
          const title = String(selectedVariant?.title || '');
          const styleMatch = title.match(/Sandy|Tiffany|Kyra|Tahlia/i);
          const styleName = styleMatch ? styleMatch[0].replace(/^./, (character) => character.toUpperCase()) : title.split(/[|•–—-]/)[0].trim();
          const lengthName = kit.key === 'shorty-cloudset' ? 'Shorty' : 'Classic';
          const summary = this.querySelector('[data-meta-selection-summary]');
          if (summary) summary.textContent = `${styleName} CloudSET (${lengthName})`;
          const bestSeller = this.querySelector('[data-meta-best-seller]');
          if (bestSeller) bestSeller.hidden = styleName.toLowerCase() !== 'tahlia';
          if (selectedVariant?.id) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', String(selectedVariant.id));
            window.history.replaceState({}, '', url);
          }
        }
        this.querySelectorAll('[data-bundle-quantity]').forEach((input) => { input.checked = Number(input.value) === this.bundleQuantity; });
        const additionalFieldset = this.querySelector('[data-additional-kits-fieldset]');
        if (additionalFieldset) additionalFieldset.hidden = this.bundleQuantity === 1;
        this.syncOfferSummaryPlacement();
        const requiredAdditions = this.requiredAdditionalKitQuantity();
        const selectedAdditions = this.totalAdditionalKitQuantity();
        const remainingAdditions = Math.max(0, requiredAdditions - selectedAdditions);
        const additionalStatus = this.querySelector('[data-additional-kits-status]');
        if (additionalStatus) additionalStatus.textContent = remainingAdditions ? `Choose ${remainingAdditions} more ${remainingAdditions === 1 ? 'set' : 'sets'} to complete your mix.` : `Your ${this.bundleQuantity}-set mix is ready.`;
        this.querySelectorAll('[data-additional-kit-row]').forEach((row) => {
          const variant = this.allKitVariants().find((item) => String(item.id) === row.dataset.variantId);
          const quantity = this.additionalKitQuantity(row.dataset.variantId);
          const isPrimaryVariant = String(row.dataset.variantId) === String(this.mainVariantId);
          const isPrimarySet = isPrimaryVariant && this.includeMainInMix;
          row.classList.toggle('is-primary-set', isPrimarySet);
          const primarySetLabel = row.querySelector('[data-primary-set-label]');
          if (primarySetLabel) primarySetLabel.hidden = !isPrimarySet;
          const output = row.querySelector('[data-additional-kit-quantity]');
          if (output) output.textContent = String(quantity + (isPrimarySet ? 1 : 0));
          const decrease = row.querySelector('[data-additional-kit-decrease]');
          if (decrease) decrease.disabled = quantity <= 0 && !isPrimarySet;
          const increase = row.querySelector('[data-additional-kit-increase]');
          if (increase) increase.disabled = !variant?.available || selectedAdditions >= requiredAdditions;
        });
        const subscriptionCadence = this.canSubscribe(this.cadence) ? this.cadence : canSubscribe30 ? '30' : canSubscribe60 ? '60' : this.cadence;
        const subscriptionPrice = this.priceState('subscription', subscriptionCadence);
        this.querySelectorAll('[data-purchase-mode]').forEach((input) => {
          const isSubscription = input.value === 'subscription';
          input.checked = input.value === this.mode;
          input.disabled = isSubscription && !canSubscribe30 && !canSubscribe60;
        });
        this.querySelector('[data-purchase-total="one-time"]').textContent = this.formatMoney(oneTimePrice.total);
        this.querySelector('[data-purchase-total="subscription"]').textContent = this.formatMoney(subscriptionPrice.total);
        const subscriptionPlans = this.querySelector('[data-subscription-plans]');
        subscriptionPlans.hidden = !offerReady || this.mode !== 'subscription';
        this.querySelectorAll('[data-cadence]').forEach((button) => {
          const available = this.canSubscribe(button.dataset.cadence);
          button.disabled = !available;
          button.classList.toggle('is-active', available && button.dataset.cadence === this.cadence);
          button.setAttribute('aria-pressed', String(available && button.dataset.cadence === this.cadence));
        });
        const subscriptionStatus = this.querySelector('[data-subscription-status]');
        subscriptionStatus.textContent = canSubscribe30 || canSubscribe60 ? this.dataset.planUnavailableLabel : this.dataset.subscriptionUnavailableLabel;
        subscriptionStatus.hidden = this.mode !== 'subscription' || this.canSubscribe(this.cadence);
        this.querySelectorAll('[data-add-styles-mode]').forEach((input) => { input.checked = (input.value === 'yes') === this.addStyles; });
        const refillFieldset = this.querySelector('[data-refill-fieldset]'); if (refillFieldset) refillFieldset.hidden = !this.addStyles;
        this.querySelectorAll('[data-refill-row]').forEach((row) => {
          const variant = this.refillVariants().find((item) => String(item.id) === row.dataset.variantId);
          const quantity = this.refillQuantity(row.dataset.variantId);
          const totalRefills = this.totalRefillQuantity();
          const input = row.querySelector('[data-refill-choice]');
          if (input) { input.checked = quantity > 0; input.disabled = !variant?.available || (!input.checked && totalRefills >= this.maxRefills); }
          const output = row.querySelector('[data-refill-quantity]');
          if (output) output.textContent = String(quantity);
          const decrease = row.querySelector('[data-refill-decrease]');
          if (decrease) decrease.disabled = quantity <= 0;
          const increase = row.querySelector('[data-refill-increase]');
          if (increase) increase.disabled = !variant?.available || totalRefills >= this.maxRefills;
          row.querySelector('[data-variant-status]').textContent = variant?.available ? row.querySelector('[data-variant-status]').textContent || this.dataset.availableLabel : this.dataset.soldOutLabel;
        });
        const discountNote = this.querySelector('[data-discount-note]'); discountNote.hidden = !percent; discountNote.textContent = percent ? this.isUltimateOffer ? `Ultimate Mix & Match savings applied. ${this.dataset.discountNote}` : `${percent}% bundle savings. ${this.dataset.discountNote}` : '';
        this.querySelector('[data-add-to-cart]').disabled = !this.hasValidSelection();
        this.syncGalleryForVariant(kit, this.mainVariant());
        this.renderQuizRecommendation();
        this.syncMetaEnhancements();
      }

      clearMessage() { this.querySelector('[data-builder-error]').hidden = true; this.querySelector('[data-builder-success]').hidden = true; }
      showError(message) { const error = this.querySelector('[data-builder-error]'); error.textContent = message; error.hidden = false; }

      async refreshCartUi() {
        if (typeof window.monster_refresh === 'function') {
          try {
            await window.monster_refresh(true);
          } catch (error) {
            if (!this.isMetaLanding) throw error;
          }
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (typeof window.monster_refresh !== 'function') {
          await new Promise((resolve) => window.setTimeout(resolve, 100));
          document.querySelector('cart-drawer')?.show?.();
        }
      }

      async addToCart() {
        if (!this.hasValidSelection()) return;
        const addButton = this.querySelector('[data-add-to-cart]'); const addLabel = this.querySelector('[data-add-label]'); const loadingLabel = this.querySelector('[data-loading-label]'); addButton.disabled = true; addLabel.hidden = true; loadingLabel.hidden = false; this.clearMessage();
        const bundleId = `pearhaus-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`; const tier = this.isUltimateOffer && this.addStyles ? 'Ultimate Mix & Match' : `Volume ${this.tierPercent()}%`; const cadence = this.mode === 'subscription' ? this.cadence : 'one-time'; const offerQuantity = this.selectedItems().reduce((sum, item) => sum + Number(item.quantity || 1), 0); const offerSource = this.isUltimateOffer && this.addStyles ? 'ultimate-mix-match-builder' : 'pdp-volume-builder'; const offerEnabled = this.isUltimateOffer || this.stockUpEnabled; const items = [];
        this.selectedItems().forEach((variant) => { const properties = { _pearhaus_kit_system: this.kit().systemKey, _pearhaus_cadence: cadence, _pearhaus_offer_mode: this.mode }; if (offerEnabled) Object.assign(properties, { _pearhaus_bundle_id: bundleId, _pearhaus_bundle_tier: tier, _pearhaus_offer_source: offerSource, _pearhaus_offer_quantity: String(offerQuantity) }); const item = { id: Number(variant.id), quantity: Number(variant.quantity || 1), properties }; if (this.mode === 'subscription') item.selling_plan = Number(this.allocation(variant, this.cadence).id); items.push(item); });
        if (this.isMetaLanding && this.freeGiftSelection()) items.push({ id: Number(this.freeGiftVariantId), quantity: 1, properties: { _pearhaus_meta_gift: 'true', _pearhaus_gift_offer: 'AD20OFF + free Classic Cloud Cluster', _pearhaus_gift_style: this.freeGiftSelection().dataset.giftStyle || '' } });
        try {
          const response = await fetch(`${this.rootUrl.replace(/\/$/, '')}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Cart request failed');
          await this.refreshCartUi();
          const success = this.querySelector('[data-builder-success]'); success.hidden = false; success.focus();
        } catch (error) {
          this.showError(this.dataset.errorLabel || 'Something went wrong. Please try again.');
        } finally {
          addLabel.hidden = false; loadingLabel.hidden = true; this.render();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
